import * as React from 'react';
import { useSetRecoilState } from 'recoil';

import { mediaGalleryAtom } from './state';

export interface MediaGalleryItem {
    url: string;
}

export interface MediaGalleryHookAPI {
    open: (medias: MediaGalleryItem[], startIndex?: number) => void;
}

/**
 * Hook API to control the media gallery.
 */
export function useMediaGallery(): MediaGalleryHookAPI {
    const setMediaGallery = useSetRecoilState(mediaGalleryAtom);

    return React.useMemo(() => {
        return {
            open: (medias, initialIndex = 0) => {
                setMediaGallery({
                    medias,
                    initialIndex,
                });
            },
        };
    }, [setMediaGallery]);
}
